import React from 'react';
import rotation from './rotation.png';

function TablaBrechasInver(props) {

    function obtenerColores() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <th key={index}><div className="rating"><span style={{ backgroundColor: eje.color }}></span>&nbsp;&nbsp;{eje.category}</div></th>
                )
            }
        })
    }

    function obtenerMaxName() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.maxName}</td>
                )
            }
        })
    }

    function obtenerMaxValue() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.maxValue}</td>
                )
            }
        })
    }

    function obtenerMinName() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.minName}</td>
                )
            }
        })
    }

    function obtenerMinValue() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.minValue}</td>
                )
            }
        })
    }

    function obtenerBrechaAbs() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.brechaAbs}</td>
                )
            }
        })
    }

    function obtenerBrechaRel() {
        return props.ejes.map((eje, index) => {
            if (eje) {
                return (
                    <td key={index}>{eje.brechaRel}</td>
                )
            }
        })
    }
    return (
        <div className="table-responsive px-4">
            <table className={props.darkMode ? "table table-hover table-dark":"table table-hover"}>
                <caption>
                    Tabla de brechas: {props.infoEje.vari.name} - {props.infoEje.year} - {props.infoReg.municipio}  &nbsp; &nbsp; 
                    <button className="btn btn-default" id="btnInfo" onClick={props.invertir} style={{padding:"0.3rem"}}>
                        <img src={rotation} className="rounded mx-auto  rotation-icon" alt="..."></img>
                    </button>
                </caption>
                <thead>
                    <tr>
                        <th scope="col"></th>
                        {obtenerColores()}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="col">Brecha absoluta</th>
                        {obtenerBrechaAbs()}
                    </tr>
                    <tr>
                        <th scope="col">Brecha relativa</th>
                        {obtenerBrechaRel()}
                    </tr>
                    <tr>
                        <th scope="col">Máximo</th>
                        {obtenerMaxName()}
                    </tr>
                    <tr>
                        <th scope="col">Valor máximo</th>
                        {obtenerMaxValue()}
                    </tr>
                    <tr>
                        <th scope="col">Mínimo</th>
                        {obtenerMinName()}
                    </tr>
                    <tr>
                        <th scope="col">Valor mínimo</th>
                        {obtenerMinValue()}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default TablaBrechasInver;